import { formatCurrency } from "@taabl/common-lib/calculators/money";
import React from "react";
import { Card } from "react-bootstrap";

const AccountSummary = ({ transaction }) => {
  if (!transaction) {
    return <div>Loading....</div>;
  }
  return (
    <Card className="summary-card mt-1 mt-md-2 mt-lg-3">
      <Card.Title>{transaction.dateRange}</Card.Title>
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div className="me-4 text-purplel">Stock Payout:</div>
          <div className="text-gray">
            {formatCurrency(transaction.stockPayout)}
          </div>
        </div>
        <div className="d-flex justify-content-between mt-1 mt-md-2">
          <div className="me-4 text-purplel">Payroll Deduction:</div>
          <div className="text-gray">
            {formatCurrency(transaction.totalDeduction)}
          </div>
        </div>
        <div className="d-flex justify-content-between mt-1 mt-md-2">
          <div className="me-4 text-purplel">Taabl Loan:</div>
          <div className="text-gray">-{formatCurrency(transaction.loan)}</div>
        </div>
        <div className="d-flex justify-content-between mt-1 mt-md-2">
          <div className="me-4 text-purplel">Taabl Fee:</div>
          <div className="text-gray">
            -{formatCurrency(transaction.taablFee)}
          </div>
        </div>
        <hr className="grey"></hr>

        <div className="d-flex justify-content-between mt-1 mt-md-2 fw-bold pb-1 pb-md-2">
          <div className="me-4 text-purplel">Net Profit:</div>
          <div className="text-gray">{formatCurrency(transaction.profit)} </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AccountSummary;
